import { createApi } from '@reduxjs/toolkit/query/react';

import { generateBaseQuseryWithReAuth } from '@/store/baseQueryReauth';
import { CustomerAddress, VerifyAddressResponse } from '@/types/Address';
import { ResponseError } from '@/types/Error';
import { SuccessResponse } from '@/types/Success';

const contentTypes = {
  applicationJson: 'application/json',
};

export interface RoqLogicSilentLoginResponse {
  success: boolean;
  message: string | null;
  exceptionMessage: string | null;
  data: string | null;
  validationErrors: string | null;
  backofficeReturnURL: string | null;
  excelBytes: string | null;
  replicatedSiteReturnURL: string | null;
}

export const appSettingsApi = createApi({
  reducerPath: 'appSettingsApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: `App` }),
  tagTypes: ['VerifyAddress', 'throwsException', 'RoqLogicSilentLogin'],
  endpoints: builder => ({
    getRoqLogicSilentLoginUrl: builder.query<RoqLogicSilentLoginResponse, void>({
      query: () => ({
        url: '/RoqLogicSilentLogin',
        method: 'GET',
      }),
      transformResponse: (response: RoqLogicSilentLoginResponse) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['RoqLogicSilentLogin'],
    }),
    verifyAddress: builder.mutation<SuccessResponse<VerifyAddressResponse>, CustomerAddress>({
      query: data => ({
        url: '/VerifyAddress',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: SuccessResponse<VerifyAddressResponse>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
    }),

    saveAvatar: builder.mutation<SuccessResponse<null>, FormData>({
      // EditAvatarRequestDTO
      query: formData => ({
        url: '/SaveAvatar',
        method: 'POST',
        body: formData, // Pass FormData directly as the body
      }),
      transformResponse: (response: SuccessResponse<null>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const { useVerifyAddressMutation, useSaveAvatarMutation, useGetRoqLogicSilentLoginUrlQuery } = appSettingsApi;
